import { type VoteTokenOfferingConvertedAmountObject } from '@capsicum/common';

export type ConvertedPricesKey = '0802df1e-4a98-4c20-98d0-2e28767b4329'; // fixes generated walletLedger.convertedPrices type

/**
 * util that the pegged amount in the array of converted prices
 * SHARED BETWEEN MOB AND WEB
 *
 * @param {currencyId} currencyId id of the currency in which we need converted price
 * @param {convertedPrices} convertedPrices converted prices for all currencyIds
 *
 * @returns {string} pegged price of the currency
 */
export const getPeggedAmount = (
	currencyId: string | undefined,
	convertedPrices?: VoteTokenOfferingConvertedAmountObject
) => {
	return parseFloat(convertedPrices?.[currencyId as ConvertedPricesKey]?.peggedPrice || '0').toFixed(2);
};
